import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { Equipment_Order_STATUSES, IPresTruncatedDataDTO } from 'API';
import { Copy, LeftArrow, PurpleOutlineWarningIcon } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { format } from 'date-fns';
import { shortDateFormat } from 'Config';
import { OneOrTwoButtons } from 'Components/OneOrTwoButtons';
import { useNavigate } from 'react-router-dom';
import { Status } from 'Modules/MedicineOrderInfo/Status';

interface IPrescriptionsListItemProps {
  titles: string[];
  item: IPresTruncatedDataDTO;
  onShowPrescriptionDetailsClick: (
    clickedPrescription: IPresTruncatedDataDTO
  ) => void;
  itemRecordStatus: string;
}

export const PrescriptionsListItemMobile = (
  props: IPrescriptionsListItemProps
) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const navigate = useNavigate();
  const orderID = props.item.prescCode || props.item.originalOrderId;

  const handleNavigate = () => {
    navigate(`/medicine/${orderID}`);
  };
  const createDate = props.item.createDate;
  const formattedCreateDate = createDate
    ? format(new Date(createDate), shortDateFormat)
    : '';
  const formattedUpdateDate = props.item.currentStatusDate
    ? format(new Date(props.item.currentStatusDate), shortDateFormat)
    : '';

  return (
    <Grid
      container
      item
      xs={12}
      alignItems={'center'}
      sx={{
        cursor: 'pointer',
        borderBottom: '1px solid #E7EDFF',
        pb: 4,
      }}
    >
      <Grid
        container
        item
        sx={{
          background: '#FFF',
          padding: '16px 16px 24px 16px',
          alignContent: 'space-between',
        }}
      >
        <Grid container item justifyContent={'space-between'}>
          <Grid item xs={6} mb={2}>
            <Typography variant='body6'>{props.titles[0]}</Typography>
            <Typography variant='body2'>
              {props.item.prescCode || dictionary.toBeDetermined}
            </Typography>
          </Grid>
          <Grid item xs={6} mb={2}>
            <Typography variant='body6'>{props.titles[1]}</Typography>
            <Typography variant='body2'>{formattedCreateDate}</Typography>
          </Grid>

          <Grid item xs={6} mb={2}>
            <Typography variant='body6'>{props.titles[2]}</Typography>
            <Typography variant='body2'>{formattedUpdateDate}</Typography>
          </Grid>
          <Grid item xs={6} mb={2}>
            <Typography variant='body6' display='block'>
              {props.titles[3]}
            </Typography>
            <Status
              status={props.item.currentStatus}
              statusLabel={props.item.currentStatusLabel || ''}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant='body6'>{props.titles[4]}</Typography>
            <Typography variant='body2'>{props.item.itemsCount}</Typography>
          </Grid>
        </Grid>
      </Grid>

      {props.item.adminIsrId && (
        <Stack
          alignItems={'center'}
          gap={'6px'}
          flexDirection={'row'}
          p='0 12px 20px'
        >
          <Avatar
            sx={{ width: '18px', height: '18px' }}
            alt={Dictionary[DICTIONARY.General].warning}
            src={PurpleOutlineWarningIcon}
          />
          <Typography variant='body6' role='note'>
            {Dictionary[DICTIONARY.Applies].openedByWing}
          </Typography>
        </Stack>
      )}

      <OneOrTwoButtons
        width='100%'
        leftButton={{
          label: dictionary.moreInfo,
          icon: LeftArrow,
          onClick: handleNavigate,
        }}
        rightButton={
          props.item.currentStatus > Equipment_Order_STATUSES.takenCareByDept4
            ? {
                label: dictionary.duplicateOrder,
                icon: Copy,
                onClick: () => {
                  navigate(`medicine/createOrder/${props.item.prescCode}`);
                },
              }
            : undefined
        }
        leftButtonRole='link'
        rightButtonRole='link'
      />
    </Grid>
  );
};
